const V_MARK_URL =
  "https://customer-assets-v7afamib.emergentagent.net/job_victory-audit/artifacts/54nf8l79_Favicon.PNG";

export const LaurelMark = ({ className = "w-8 h-8", chip = false }) => {
  const img = (
    <img
      src={V_MARK_URL}
      alt=""
      aria-hidden="true"
      className={`${className} object-contain ${chip ? "" : "mix-blend-multiply"}`}
    />
  );
  if (!chip) return img;
  return (
    <span className="inline-flex items-center justify-center rounded-full bg-ivory p-1.5 shadow-sm">
      {img}
    </span>
  );
};

export const Logo = ({ dark = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <LaurelMark className="w-9 h-9" chip={dark} />
    <div className="leading-none">
      <span
        className={`block font-serif text-lg tracking-wide ${
          dark ? "text-[#EDE4D3]" : "text-[#1F3A5F]"
        }`}
      >
        Lady of Victory<sup className="text-[0.5em]">®</sup>
      </span>
      <span className="block text-[0.6rem] uppercase tracking-[0.3em] text-[#A08C6E] mt-1">
        Alignment Check
      </span>
    </div>
  </div>
);
